import type { Hit } from 'instantsearch.js'
import groupBy from 'lodash/groupBy'
import type { AlgoliaTrialHit } from '../const'

/**
 * Gets unique trial locations by taking the first location from each nctId group
 */
export default function getUniqueTrialsFromTrialLocations(
  trilLocations: Hit<AlgoliaTrialHit>[],
) {
  return Object.values(groupBy(trilLocations, 'nctId'))
    .map((locations) => locations[0])
    .filter((trial): trial is NonNullable<typeof trial> => trial !== null)
}
